<template>
    <section class="home-page02">
        <transition name="covering">
            <div class="covering" v-show="isShow">
                <!-- <div class="shut" @click.stop.prevent="shut"></div> -->
                <transition name="covering">
                    <div class="inputs" v-show="inputs">
                        <div class="shut_s" @click="shut_s">
                            <img src="../../assets/images/clue/2.png" alt="明日方舟" />
                        </div>
                        <div class="btn-wrap">
                            <img class="please" src="../../assets/images/clue/password.png" alt />
                            <input
                                @keyup.enter="confirm"
                                ref="passwords"
                                type="number"
                                onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                :max="9999999"
                                oninput="if(value.length > 4)value = value.slice(0, 4)"
                                v-model="passwords"
                            />
                            <div class="confirm" @click="confirm">
                                <img src="../../assets/images/clue/Confirms.png" alt />
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
        <div class="container">
            <div class="clue-wrap">
                <div
                    class="clue-box"
                    :class="[`clue0${index+1}`, { 'active': hvoerIndex == index && item.order <= CLUE_STAGE }]"
                    :key="`clue-${index}`"
                    v-for="(item, index) in clueList"
                >
                    <img :src="clueImg(item)" class="clue-bg" alt />
                    <div
                        class="clue-hover"
                        @click="jumpTo(item.to)"
                        @mouseover="mover(index)"
                        @mouseleave="mleave"
                    ></div>
                </div>
                <img :src="stageImg()" class="stage" alt />
            </div>
            <div class="btn-wrap">
                <div class="unlock-btn">
                    <img src="../../assets/images/clue/unlock.png" alt />
                    <div class="if_cont" @click="clicks"></div>

                    <p class="tip">
                        <img src="../../assets/images/clue/unlock_icon.png" class="unlock_icon" alt />
                        <span class="tip-01">{{CLUE_STAGE+1}}</span>
                        <span class="hd">/</span>
                        <span class="tip-02">7</span>
                        <img src="../../assets/images/clue/unlock_text.png" class="unlock_text" alt />
                    </p>
                </div>
                <a href="https://discord.gg/arknights" target="_blank" class="dis-btn">
                    <img src="../../assets/images/clue/gotodis.png" alt />
                </a>
            </div>
        </div>
    </section>
</template>

<script>
import Flipper from "../../components/Flipper";
export default {
    name: "home-page02",
    components: { Flipper },
    data: () => ({
        clueList: [
            {
                bg: require("../../assets/images/clue/clue01_bg.png"),
                active: require("../../assets/images/clue/clue01.png"),
                order: 6,
                to: "https://twitter.com/ArknightsEN/status/1215121015006617600"
            },
            {
                bg: require("../../assets/images/clue/clue02_bg.png"),
                active: require("../../assets/images/clue/clue02.png"),
                order: 5,
                to: "https://twitter.com/ArknightsEN/status/1205880125629370368"
            },
            {
                bg: require("../../assets/images/clue/clue03_bg.png"),
                active: require("../../assets/images/clue/clue03.png"),
                order: 4,
                to: "https://twitter.com/ArknightsEN/status/1202978435238252545"
            },
            {
                bg: require("../../assets/images/clue/clue04_bg.png"),
                active: require("../../assets/images/clue/clue04.png"),
                order: 3,
                to: "https://twitter.com/ArknightsEN/status/1182143717978918912"
            },
            {
                bg: require("../../assets/images/clue/clue05_bg.png"),
                active: require("../../assets/images/clue/clue05.png"),
                order: 2,
                to: "https://twitter.com/ArknightsEN/status/1167285815526879232"
            },
            {
                bg: require("../../assets/images/clue/clue06_bg.png"),
                active: require("../../assets/images/clue/clue06.png"),
                order: 1,
                to: "https://twitter.com/ArknightsEN/status/1157863732229410816"
            },
            {
                bg: require("../../assets/images/clue/clue07_bg.png"),
                active: require("../../assets/images/clue/clue07.png"),
                order: 0,
                to: "https://twitter.com/ArknightsEN/status/1146675156284137472"
            }
        ],
        hvoerIndex: -1,
        timer: "",
        isShow: false,
        inputs: false,
        // count_Down:false,
        // curStartTime: "2020-02-11 21:14:55",
        // day: "0",
        // hour: "0",
        // hours: "0",
        password: "2531",
        passwords: ""
    }),
    created() {},
    mounted() {
        clearInterval();
    },
    watch: {},
    computed: {
        CLUE_STAGE() {
            return this.$store.state.CLUE_STAGE;
        },
        LOCK_TEXT_IMG() {
            if (this.CLUE_STAGE >= 6) {
                return require("../../assets/images/clue/unlock_text.png");
            } else {
                return require("../../assets/images/clue/unlock_text.png");
            }
        }
    },
    methods: {
        clicks: function() {
            this.isShow = true;
            this.inputs = true;
        },
        shut_s: function() {
            this.inputs = false;
            this.isShow = false;
        },
        confirm: function() {
            if (this.password === this.$refs.passwords.value) {
                this.inputs = false;
                this.isShow = false;
                // this.$router.push(
                //   {name:'countDown',params:{id:'000'}}
                //   )
                let details = this.$router.resolve({
                    path: "/countDown",
                    query: { id: 123 }
                });
                window.open(details.href, "_blank");
            } else {
                console.log("密码错误");
                alert("wrong password");
            }
            (this.passwords = ""), console.log(this.$refs.passwords.value);
        },

        clueImg(item) {
            if (item.order <= this.CLUE_STAGE) {
                return item.active;
            } else {
                return item.bg;
            }
        },
        stageImg() {
            if (this.CLUE_STAGE <= 2) {
                return require("../../assets/images/clue/stage3.png");
            } else {
                return require(`../../assets/images/clue/stage${this
                    .CLUE_STAGE + 1}.png`);
            }
        },
        mover(index) {
            this.hvoerIndex = index;
        },
        mleave() {
            this.hvoerIndex = -1;
        },
        jumpTo(url) {
            if (url) {
                window.open(url, "_blank");
            } else {
                alert("Coming soon!");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.home-page02 {
    background: url("../../assets/images/clue/bg.png") no-repeat;
    background-size: cover;
    background-position: center center;

    .container {
        position: relative;
        width: pxTorem(848px);
        top: 20%;
        left: 50%;
        transform: translateX(-50%);

        .clue-wrap {
            position: relative;
            width: pxTorem(848px);
            height: pxTorem(524px);

            .clue-box {
                display: block;
                position: absolute;
                width: pxTorem(115px);
                cursor: pointer;

                .clue-hover {
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    z-index: 4;
                }

                &.active {
                    cursor: url("../../assets/images/clue/mouse.png"), auto;

                    &::after {
                        box-shadow: 0 0 36px 0.5px #fff;
                    }
                }

                &::after {
                    content: "";
                    width: 70%;
                    height: 70%;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    z-index: -1;
                    transition: all 0.3s ease-in-out;
                }
                .clue-bg {
                    width: 100%;
                }
            }

            .clue01 {
                top: pxTorem(23px);
            }
            .clue02 {
                top: pxTorem(113px);
                left: pxTorem(235px);
            }
            .clue03 {
                top: pxTorem(0px);
                left: pxTorem(462px);
            }
            .clue04 {
                top: pxTorem(53px);
                right: pxTorem(2px);
            }
            .clue05 {
                left: pxTorem(332px);
                bottom: 0;
            }
            .clue06 {
                left: pxTorem(550px);
                bottom: pxTorem(78px);
            }
            .clue07 {
                left: pxTorem(70px);
                bottom: pxTorem(40px);
            }

            .stage {
                width: pxTorem(732px);
                position: absolute;
                top: pxTorem(30px);
                left: pxTorem(51px);
                z-index: 3;
            }
        }
        .btn-wrap {
            width: 100%;
            height: pxTorem(80px);
            position: relative;
            text-align: center;
            margin-top: pxTorem(50px);

            .unlock-btn {
                position: relative;
                height: 100%;
                img {
                    height: 100%;
                }
                .tip {
                    width: 100%;
                    height: 76%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    font-family: "SourceHanSansSubset";
                    display: flex;
                    justify-content: center;
                    align-items: flex-end;
                    color: #313131;

                    .unlock_icon {
                        display: block;
                        width: pxTorem(50px);
                        height: auto;
                        margin-top: pxTorem(15px);
                    }

                    .tip-01 {
                        font-weight: bold;
                        font-size: pxTorem(38px);
                        margin-bottom: pxTorem(3px);
                    }
                    .hd {
                        font-size: pxTorem(38px);
                        font-weight: bold;
                        margin-bottom: pxTorem(4px);
                    }
                    .tip-02 {
                        font-size: pxTorem(38px);
                        font-weight: bold;
                        margin-left: pxTorem(1px);
                        margin-bottom: pxTorem(3px);
                    }
                    .unlock_text {
                        height: 50%;
                        margin-left: pxTorem(10px);
                        margin-bottom: pxTorem(13px);
                    }
                }
                .if_cont {
                    width: 292px;
                    height: 62px;
                    position: absolute;
                    left: 278px;
                    top: 0;
                    z-index: 999;
                }
            }

            .dis-btn {
                display: block;
                height: pxTorem(70px);
                position: absolute;
                right: 0;
                bottom: pxTorem(5px);
                img {
                    height: 100%;
                }
            }
        }
    }
    .covering {
        width: 100%;
        height: 100%;
        // background: url("../../assets/images/clue/PC_2.png") no-repeat;
        background-size: cover;
        background-position: center center;
        .count-Down {
            width: 1000px;
            height: 60px;
            line-height: 60px;
        }
        .inputs {
            width: 543px;
            height: 268px;
            background: #1b191a;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
            .confirm {
                width: 245px;
                height: 47px;
                background: url("../../assets/images/clue/confirm.png")
                    no-repeat;
                background-size: cover;
                position: absolute;
                top: 181px;
                left: 153px;
                img {
                    width: 142px;
                    position: relative;
                    top: 53%;
                    left: 50%;
                    transform: translate(-53%, -50%);
                    -webkit-transform: translate(-53%, -50%);
                }
            }
            input {
                border: 0px;
                height: 47px;
                width: 363.65px;
                position: absolute;
                left: 79px;
                background: #707070;
                top: 102px;
                outline: none;
                padding-left: 20px;
                font-size: 20px;
                color: #fff;
            }
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
            }
            input[type="number"] {
                -moz-appearance: textfield;
            }

            .shut_s {
                position: absolute;
                right: 0;
                top: 0;
                background: #211f1f;
                width: 48px;
                height: 48px;
                img {
                    margin-left: 6px;
                }
            }
            .please {
                width: 225px;
                position: absolute;
                left: 154px;
                top: 55px;
            }
        }
        .count-Down {
            position: relative;
            top: 50%;
            left: 62%;
            transform: translate(-50%, -50%);
            -webkit-transform: translate(-50%, -50%);
        }
        .shut {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 10px;
            right: 10px;
            background: url("../../assets/images/clue/2.png") no-repeat;
            background-size: cover;
        }
    }

    .covering-enter-active,
    .covering-leave-active {
        transition: all 0.5s ease-in-out;
    }
    .covering-enter,
    .covering-leave-to {
        opacity: 0;
    }
}
</style>
